import React from 'react';
import {AnalyticsCellRender} from './AccountSummaryConfig';
import {guidanceType} from '../../../../util/uiconstants';

export default function HelixAccountDesignationTable(props) {
	const {renderGrid, body} = props;

	const extendColumns = (columnDefinition) => {
		return [
			...columnDefinition.slice(0, 2),
			{
				headerName: '',
				cellRenderer: 'helixColumn',
				field: 'analytics',
				suppressSizeToFit: false,
				width: '40'
			},
			...columnDefinition.slice(2, columnDefinition.length)
		];
	};

	const guidances = body?.guidances
		?.filter((g) => g.guidanceTypeId === guidanceType.HelixComponent)
		.sort((a, b) => a.guidanceDisplayOrder - b.guidanceDisplayOrder)
		.slice(0, 6);

	const extendFrameworkComp = (frameworkComponents) => {
		return {
			...frameworkComponents,
			helixColumn: (props) => {
				return <AnalyticsCellRender accountId={props.data.id} guidances={guidances} />;
			}
		};
	};

	return renderGrid && renderGrid({extendColumns, extendFrameworkComp});
}
